/** Brazilian formatting utilities */

export const formatBRL = (v) =>
  new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v) || 0);

export const formatNumber = (v, digits = 0) =>
  new Intl.NumberFormat("pt-BR", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(v) || 0);

export const formatPct = (v, digits = 1) => `${formatNumber(v, digits)}%`;

export const formatCNPJ = (cnpj) => {
  const d = (cnpj || "").replace(/\D/g, "");
  if (d.length !== 14) return cnpj || "";
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
};

export const formatCEP = (cep) => {
  const d = (cep || "").replace(/\D/g, "");
  if (d.length !== 8) return cep || "";
  return `${d.slice(0, 5)}-${d.slice(5)}`;
};

export const formatDateBR = (iso) => {
  if (!iso) return "";
  try {
    const text = String(iso);
    if (/^\d{4}-\d{2}-\d{2}$/.test(text)) return text.split("-").reverse().join("/");
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? text : d.toLocaleDateString("pt-BR", { timeZone: "America/Sao_Paulo" });
  } catch (e) { return iso; }
};

export const formatDateTimeBR = (iso) => {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" });
  } catch (e) { return iso; }
};


export const todaySaoPaulo = () => new Intl.DateTimeFormat("sv-SE", { timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date());
